import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'hooks/useTheme';

export const HorizontalListSeperator = () => {
	const { theme } = useTheme();

	return <View style={{ width: '90%', alignSelf: 'center', borderTopWidth: 0, borderColor: theme.lightgray, marginVertical: 15 }} />;
};
